import punycode from 'punycode';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import withOptions from 'utils/functions/withOptions.util';

// SEE: https://en.wikipedia.org/wiki/Quotation_mark
const QUOTES = Object.freeze([171, 187, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8223]);

const checkEmojisAndQuotes = withOptions(({ text, strat: stratFromOptions }) => {
  const strat = fromAnyToTrimmed(stratFromOptions) || 'unicode';
  if (strat !== 'utf16') throw new Error(`Invalid strategy strat: ${strat}`);

  for (let i = 0; i < text.length; i += 1) {
    const c = text.charCodeAt(i);
    // emoji has high charCode, usually over 50000, to be safe, set as 5000
    if (c > 5000 && !QUOTES.includes(c)) return true;
  }
  return false;
});

const checkAboveGsm7Bit = withOptions(({ text, strat: stratFromOptions }) => {
  const strat = fromAnyToTrimmed(stratFromOptions) || 'unicode';
  if (strat !== 'utf16') throw new Error(`Invalid strategy strat: ${strat}`);

  // SEE: https://en.wikipedia.org/wiki/GSM_03.38
  // using ucase2 to encode so '£' will not be treated as odd character
  const ucas2 = punycode.encode(text);
  const hasEmoji = checkEmojisAndQuotes({ text, strat });

  for (let i = 0; i < ucas2.length; i += 1) {
    if (hasEmoji || ucas2.charCodeAt(i) > 127) return true;
  }

  return false;
});

export default checkAboveGsm7Bit;
